module.exports = __webpack_public_path__ + "img/SWP_Shield_08 (2).1662c6a9.png";